var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import "../../Styling.js";
import { Stack } from "@fluentui/react/lib/Stack";
import "../Heading.js";
import "../OverflowSet.js";
import { FocusZone } from "@fluentui/react/lib/FocusZone";
import { Subhead } from "../Heading/Subhead.js";
import { mergeStyles } from "@fluentui/style-utilities";
import { OverflowSet } from "@fluentui/react/lib/OverflowSet";
const defaultClassName = "ane-FormSection";
const _onRenderHeader = (props) => {
  if (!props)
    return null;
  const { heading, overflowSetProps } = props;
  return /* @__PURE__ */ jsx(Fragment, { children: !!heading && /* @__PURE__ */ jsxs(Stack, { horizontal: true, verticalAlign: "center", grow: true, children: [
    /* @__PURE__ */ jsx(
      Subhead,
      __spreadProps(__spreadValues({
        className: mergeStyles(`${defaultClassName}-heading`, {
          marginBottom: 0
        })
      }, props.subheadProps), {
        children: heading
      })
    ),
    !!overflowSetProps && /* @__PURE__ */ jsx(FocusZone, { style: { marginLeft: "auto" }, children: /* @__PURE__ */ jsx(OverflowSet, __spreadValues({}, overflowSetProps)) })
  ] }) });
};
const FormSection = (props) => {
  const _a = props, { className, heading, overflowSetProps, children, onRenderHeader = _onRenderHeader } = _a, rest = __objRest(_a, ["className", "heading", "overflowSetProps", "children", "onRenderHeader"]);
  return /* @__PURE__ */ jsxs(
    Stack,
    __spreadProps(__spreadValues({
      className: mergeStyles(
        defaultClassName,
        {
          marginBottom: "24px"
        },
        className
      ),
      tokens: { childrenGap: 14 }
    }, rest), {
      children: [
        onRenderHeader(props, _onRenderHeader),
        children
      ]
    })
  );
};
export {
  FormSection,
  FormSection as default
};
//# sourceMappingURL=FormSection.js.map
